/**
 * Build a frozen snapshot for the turn-start overlay from authoritative game state.
 * Values are captured once when the overlay opens so later BattleUI updates do not remount it.
 */

function detectReducedMotion() {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (_) {
    return false;
  }
}

/**
 * @param {object} gameState
 * @param {string|number} userId
 * @param {boolean} isMobile
 * @param {{ turnLabel?: string | null, timeToActText?: string }} [copy]
 */
export function buildTurnStartOverlaySnapshot(gameState, userId, isMobile, copy = {}) {
  if (!gameState || userId == null) {
    throw new Error('buildTurnStartOverlaySnapshot: gameState and userId are required');
  }

  const turnNumber =
    typeof gameState.turnNumber === 'number' && !Number.isNaN(gameState.turnNumber)
      ? gameState.turnNumber
      : null;

  const playerState = gameState.state?.[userId] ?? gameState.state?.[String(userId)] ?? null;

  return {
    turnNumber,
    health: playerState?.health ?? 0,
    intel: playerState?.intelligence ?? 0,
    isMobile: Boolean(isMobile),
    turnLabel: copy.turnLabel ?? null,
    timeToActText: copy.timeToActText ?? '',
    reducedMotion: detectReducedMotion(),
  };
}
